import { render, staticRenderFns } from "./optionsPress.vue?vue&type=template&id=299f19e5&scoped=true&"
import script from "./optionsPress.vue?vue&type=script&lang=js&"
export * from "./optionsPress.vue?vue&type=script&lang=js&"
import style0 from "./optionsPress.vue?vue&type=style&index=0&id=299f19e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f19e5",
  null
  
)

export default component.exports